module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid register"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 m-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('h1', {
    staticClass: "logo-name style-scope page-auth-login"
  }, [_c('a', {
    attrs: {
      "href": "https://royalpag.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), (!_vm.isVerificado) ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n            Validar dados de cadastro?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray pt-3 pb-3",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto",
      "margin-bottom": "0px !important"
    }
  }, [_vm._v("Informe o e-mail cadastrado para verificação.")]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.email.$error
    },
    attrs: {
      "placeholder": "E-mail",
      "type": "email",
      "autocomplete": "username"
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "email", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.email.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.usuario.email.$dirty && !_vm.$v.usuario.email.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (!_vm.$v.usuario.email.email) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Email inválido!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block mb-3",
    style: (_vm.color),
    attrs: {
      "type": "submit",
      "value": "Verificar",
      "disabled": !_vm.isWholeModelValid
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "sign-in",
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Já é um membro?  "), _c('router-link', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "to": "/auth/login"
    }
  }, [_vm._v("Entrar")])], 1)])])])])])]) : _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n            Verificação de conta completa!\n          ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row pt-3"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block mb-3",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isWholeRedirect),
      expression: "!isWholeRedirect"
    }],
    staticClass: "form-group text-center pb-0 mb-0 text-default-gray",
    staticStyle: {
      "padding-top": "3px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.contador))])])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-default-gray pt-3 pb-3",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto",
      "margin-bottom": "0px !important"
    }
  }, [_vm._v("Todos seus dados já foram verificados. "), _c('br'), _vm._v("Obrigado e aproveite nosso portal.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c5a96d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/register/verificar.vue
// module id = AB3p
// module chunks = 36